import React, { useContext } from 'react';
import { st, classes } from './ItemName.st.css';
import ItemNameIcon from './ItemNameIcon';
import ItemNameTitle from './ItemNameTitle';
import ItemNameSubTitle from './ItemNameSubtitle';
import useObservable from '../../../../../../../Shared/Hooks/useObservable.Hook';
import { getItemRenameStatus } from '../../../../../../Services/ItemRename.service';
import { getAppSettings } from '../../../../../../Services/AppSettings.service';
import { ItemAvailabilityBadges } from '../ItemAvailabilityBadges/ItemAvailabilityBadges';
import { Availability } from '../../../../../../../Constants/Permissions';
import { ItemSubtitleVisibilityContext } from '../../ItemSubtitleVisibilityContext';

const ItemName = (props: any) => {
  const [, renameInfo]: any = useObservable(getItemRenameStatus());
  const [, AppSettings]: any = useObservable(getAppSettings());
  const { subtitleVisible } = useContext(ItemSubtitleVisibilityContext);

  const isMobile = AppSettings !== undefined ? AppSettings?.isMobile : false;
  const isMembersArea = AppSettings?.isMembersArea ?? false;

  const { item, handleChangeFolder } = props;

  const handleOnClick = () => {
    if (
      renameInfo &&
      renameInfo?.renamingStatus === true &&
      item.id === renameInfo?.folderId
    ) {
    } else {
      handleChangeFolder(item);
    }
  };

  return (
    <>
      <div
        className={
          classes.itemNameContainer +
          ' ' +
          (isMobile ? classes.itemNameContainerMobileView : '')
        }
        onClick={handleOnClick}
      >
        <div className={classes.itemNameIcon}>
          <ItemNameIcon item={item} />
        </div>
        <div
          className={st(classes.itemNameContent, { isMobile, isMembersArea })}
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              handleOnClick();
            }
          }}
        >
          <div className={classes.itemNameTitle}>
            {renameInfo &&
            renameInfo.renamingStatus === true &&
            renameInfo.folderId === item.id ? (
              <ItemNameTitle item={item} renameInfo={renameInfo} />
            ) : (
              <ItemNameTitle item={item} />
            )}
          </div>
          {renameInfo &&
          renameInfo?.renamingStatus === true &&
          item.id === renameInfo?.folderId ? null : subtitleVisible === true ? (
            <div className={classes.itemNameSubTitle}>
              <ItemNameSubTitle
                item={item}
                handleChangeFolder={handleChangeFolder}
              />
            </div>
          ) : null}
          <ItemAvailabilityBadges
            availability={item.availability as Availability}
            path={item.path}
          />
        </div>
      </div>
    </>
  );
};

export default ItemName;
